import { render } from "./form-register.vue?vue&type=template&id=6c90c354&scoped=true&lang=html"
import script from "./form-register.vue?vue&type=script&lang=js"
export * from "./form-register.vue?vue&type=script&lang=js"

import "./form-register.vue?vue&type=style&index=0&id=6c90c354&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c90c354"]])

export default __exports__